export function navFunction() {
    const $body = $("body");
    const header = $(".header");
    let flag = 0;
    // const headerNav = $(".header-navigation");
    let mainMenuItem = $(".main-menu li, .main-menu .item, .main-add-menu li, .main-add-menu .item");
    const cookie = $(".cookies-info");
    const loginBtn = header.find(".log-in-button");
    let mobileBurger = $(".header .mobile-burger");

    loginBtn.on("click", function (e) {
        e.preventDefault();
        let $this = $(this);
        if ($body.hasClass("no-touch")) {
            if (!$this.hasClass("show")) {
                $this.addClass("show").attr("aria-expanded", true).parent().find(".dropdown-login").addClass("show");
            } else {
                $this.removeClass("show").attr("aria-expanded", false).parent().find(".dropdown-login").removeClass("show");
            }
        } else {
            $(this).toggleClass("show").parent().find(".dropdown-login").slideToggle(200);
        }
    });
    $(document).keydown(function (event) {
        if (event.keyCode == 27 && $body.hasClass("menu-open")) {
            flag = 0;
            $body.removeClass("menu-open");
            mobileBurger.attr("aria-expanded", false);
            mobileBurger.focus();
            if ($body.hasClass("with-cookies")) {
                cookie.slideDown(300);
            }
        }
    });

    mobileBurger.on("click", function () {
        let $this = $(this);
        if ($body.hasClass("with-cookies")) {
            cookie.slideToggle(300);
        }
        if (!$body.hasClass("menu-open") && flag != 1) {
            $body.addClass("menu-open");
            $this.attr("aria-expanded", true);
            flag = 1;
            $(".header-navigation").find("a").first().focus();
        } else {
            flag = 0;
            mobileBurger.focus();
            $body.removeClass("menu-open");
            $this.attr("aria-expanded", false);
        }

        if (loginBtn.hasClass("show")) {
            loginBtn.removeClass("show").next("ul").slideUp(300);
        }
    });


    mainMenuItem.each(function (i, item) {
        let it = $(item);
        let linkText = it.find(".main-link").text();
        it.find("ul").attr("id", linkText);
        let button = $(`<button type='button' aria-expanded='false' aria-controls="${linkText}"><i>dropdown opener</i><svg width=\"7\" height=\"10\" viewBox=\"0 0 7 10\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\">\n" +
            "<path d=\"M0 1.35447L1.35447 0L6.35927 5L1.35447 10L0 8.64553L3.69086 5L0 1.35447Z\" fill=\"#08162F\"/>\n" +
            "</svg>\n</button>`);
        let ico = $("<svg width=\"7\" height=\"10\" viewBox=\"0 0 7 10\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\">\n" +
            "<path d=\"M0 1.35447L1.35447 0L6.35927 5L1.35447 10L0 8.64553L3.69086 5L0 1.35447Z\" fill=\"#08162F\"/>\n" +
            "</svg>");

        if (it.find("ul, div").length) {
            // it.addClass("has-dropdown");
            // it.find("ul").wrap("<div class='dropdown'></div>");
            // if ($body.hasClass("touch")) {
            //     it.find(">ul, > div").before(button);
            // } else {
            //     it.find(">a, >span").append(ico);
            // }

            it.find(">ul, > div").before(button);
        }


        button.on("click", function (e) {
            e.preventDefault();

            let parent = $(this).parent("li, .item");
            if (!parent.hasClass("opened-dropdown")) {
                parent.siblings("li, .item").removeClass("opened-dropdown");
                parent.addClass("opened-dropdown");
                // if (window.innerWidth < 1200) {
                if ($body.hasClass("touch")) {
                    parent.siblings("li, .item").find(">ul, > div").slideUp(300);
                    parent.find(">ul, > div").slideDown(300);
                }

            } else {
                parent.removeClass("opened-dropdown");
                if ($body.hasClass("touch")) {
                    parent.find(">ul, > div").slideUp(300);
                }
            }
        });
    });

    $(".main-add-menu ul li, .main-add-menu div .item").on("mouseenter mouseleave", function (e) {
        let list = $("ul, div", this);
        if (window.innerWidth >= 1200 && list.length) {
            let listOffset = list.offset();
            let listLeft = listOffset.left;
            let listWidth = list.width();
            let containerWidth = $(".main-add-menu").width();

            let isEntirelyVisible = (listLeft + listWidth <= containerWidth);

            if (!isEntirelyVisible) {
                $(this).addClass("edge");
            } else {
                $(this).removeClass("edge");
            }
        }
    });
    $(".mobile-log-in").on("click", function () {
        $(".header .mobile-burger").trigger("click");
        loginBtn.trigger("click");
        mobileBurger.attr("aria-expanded", true);
        loginBtn.focus();
    });

    $body.focusin(function (e) {
        if (!$(e.target).parents().hasClass("header-navigation")) {
            if ($body.hasClass("menu-open")) {
                $body.removeClass("menu-open");
                mobileBurger.attr("aria-expanded", false);
                mobileBurger.focus();
                setTimeout(function () {
                    flag = 0;
                }, 500);
            }
        }
        if (!$(e.target).parents().hasClass("dropdown-login")) {
            if ($(".dropdown-login").hasClass("show")) {
                $(this).removeClass("show").parent().find(".dropdown-login").toggleClass("show");
                $(".log-in-button").removeClass("show").attr("aria-expanded", false);
            }
        }
    });

    if (window.innerWidth > 1200) {
        $(".header-navigation").removeAttr("role");
    }

    $(window).on("load resize", function () {
        if (window.innerWidth < 1200 && $(".header .main-add-menu").length && !$(".header .main-add-menu").hasClass("mobile-view")) {
            header.find(".main-add-menu").addClass("mobile-view").appendTo(".header .header-holder");
            $body.addClass("mobile-has-add-menu");
        }
    });
}


// WEBPACK FOOTER //
// ./assets/js/modules/navFunction.js